import { Box, TextField, Typography } from "@mui/material"
import type { ReactElement } from "react"
import { Controller, useFormContext } from "react-hook-form"

import type { PaymentTermsSchemaFormValues } from "../schemas/PaymentTermsSchema"

import { FIELD_ERROR_CLASSES, FIELD_LABEL_CLASSES, TEXT_FIELD_STYLING_PROPS } from "@/constants/forms"

const AddPaymentDiscount = ({
  partsIndex = 0,
  optionsIndex = 0,
}: {
  partsIndex: number
  optionsIndex: number
}): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext<PaymentTermsSchemaFormValues>()

  return (
    <div>
      <Box className='mt-4 flex gap-3'>
        <Controller
          name={`options.${optionsIndex}.parts.${partsIndex}.discount.percentage`}
          control={control}
          render={({ field }) => (
            <Box className='relative'>
              <label className={FIELD_LABEL_CLASSES}>
                Discount<span className='text-red-600'>*</span>
              </label>
              <TextField
                {...field}
                {...TEXT_FIELD_STYLING_PROPS}
                value={field.value}
                placeholder='-'
                slotProps={{
                  input: {
                    endAdornment: <Typography className='text-sm'>%</Typography>,
                  },
                  htmlInput: {
                    className: "hide-stepper",
                  },
                }}
              />
            </Box>
          )}
        />
        <Typography variant='body2' className='mt-6 content-center text-gray-700'>
          applicable if paid in
        </Typography>
        <Controller
          name={`options.${optionsIndex}.parts.${partsIndex}.discount.applicableIfWithinDays`}
          control={control}
          render={({ field }) => (
            <Box className='relative'>
              <label className={FIELD_LABEL_CLASSES}>
                Days<span className='text-red-600'>*</span>
              </label>
              <TextField
                {...field}
                {...TEXT_FIELD_STYLING_PROPS}
                value={field.value}
                placeholder='-'
                slotProps={{
                  htmlInput: {
                    className: "hide-stepper",
                  },
                }}
              />
            </Box>
          )}
        />
      </Box>
      <div className={FIELD_ERROR_CLASSES}>
        <div>{errors?.options?.[optionsIndex]?.parts?.[partsIndex]?.discount?.percentage?.message}</div>
        <div>{errors?.options?.[optionsIndex]?.parts?.[partsIndex]?.discount?.applicableIfWithinDays?.message}</div>
      </div>
    </div>
  )
}

export default AddPaymentDiscount
